import React from 'react'
import ExclusiveToggleGroup from '../../components/editors/toggle/ExclusiveToggleGroup'
import { intl } from '../../../i18n'
import { AggregateField } from '../../../domain/entity/WbsItemEntity'

export const AggregateFieldToggleGroup = (props: {
  value: AggregateField
  onChange: (value: AggregateField) => void
  height?: number
}) => {
  return (
    <ExclusiveToggleGroup
      value={props.value}
      options={[
        {
          value: AggregateField.WBS_ITEM_COUNT,
          label: intl.formatMessage({ id: 'projectPlan.wbs.item.count' }),
        },
        {
          value: AggregateField.WBS_ITEM_WORKLOAD,
          label: intl.formatMessage({
            id: 'projectPlan.wbs.item.workload',
          }),
        },
      ]}
      onChange={value => props.onChange(value as AggregateField)}
      height={props.height}
    />
  )
}
